export default __webpack_public_path__ + "static/media/vfd.912f82ba.webp";